// extracted by mini-css-extract-plugin
export default {"root":"VTk5V__root","scrubber":"YXZFJ__scrubber"};